module.exports = __webpack_public_path__ + "static/media/email.7c722e48.svg";